import { BooleanField, EnumField, ListField, TextField } from 'framework/ui/field';
import { SectionRow } from 'framework/ui/layout';
import {
  EMPLOYEE_CONTRACT_ASSIGMENT_TYPES,
  EMPLOYEE_WORKPLACE_LOCATION,
  ContractTypeField,
} from 'domain/shared/employee';
import { RELOCATION_OPTIONS, WORKING_SCHEDULE } from 'domain/recruiting/vacancy/shared/vacancyService';
import VacancyOfficeField from 'domain/recruiting/vacancy/shared/field/VacancyOfficeField';

type VacancyDetailsFieldProps = {
  value?: any;
};

const VacancyDetailsField = ({ value = {} }: VacancyDetailsFieldProps) => {
  return (
    <SectionRow>
      <VacancyOfficeField label="Location (Office)" value={value.office} />
      <ListField value={value.assignmentType} label="Employment type">
        <EnumField options={EMPLOYEE_CONTRACT_ASSIGMENT_TYPES} />
      </ListField>
      <EnumField options={RELOCATION_OPTIONS} value={value.relocationOption} label="Relocation options" />
      <BooleanField value={value.hasProbation} label="Has probation" />
      <ListField value={value.contractType} label="Contract type">
        <ContractTypeField />
      </ListField>
      <ListField value={value.workplaceLocation} label="Working mode">
        <EnumField options={EMPLOYEE_WORKPLACE_LOCATION} />
      </ListField>
      <EnumField value={value.workingSchedule} label="Working schedule" options={WORKING_SCHEDULE} />
      <TextField
        isVisible={!!value.workingScheduleDescription}
        value={value.workingScheduleDescription}
        label="Working schedule description"
      />
    </SectionRow>
  );
};

export default VacancyDetailsField;
